export enum OrganizationsTableColumn {
  NAME = 'name',
  PACKAGE = 'package',
  ADDONS = 'addons',
  SSO_CONFIG = 'ssoConfig',
  ACADEMY_CONFIG = 'academyConfig',
  ACTIONS = 'actions',
}

export const ORGANIZATIONS_ADDONS_SEPARATOR: string = '\n';
